import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import { NewJobsite, JobsiteOverview, UpdateJobsite } from '../models/jobsite.model';
import { Tuple } from '../models/tuple.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class JobsiteService {
    private readonly GetAllJobsitesApiAddress = 'api/admin/GetAllJobsitesForUser';
    private readonly AddNewJobsiteApiAddress = 'api/admin/AddNewJobsite';
    private readonly UpdateJobsiteApiAddress = 'api/admin/UpdateJobsite';
    private readonly GetJobsiteDetailsApiAddress = 'api/admin/GetJobsiteDetails';

    constructor(private _http: HttpClient) { }

    public getJobsiteDetails(jobsiteId: number): Observable<NewJobsite> {
      const params = {
        params: new HttpParams().set('jobsiteId', jobsiteId.toString())
      };
      return this._http.get<NewJobsite>(this.GetJobsiteDetailsApiAddress, params).pipe(catchError(this.handleError));
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('jobsiteId', jobsiteId.toString());
        // return this._http.get(this.GetJobsiteDetailsApiAddress, { search: params }).share().map(
        //     (response: Response) => <NewJobsite>response.json()).catch(this.handleError);
    }

    public getAllJobsites(): Observable<JobsiteOverview[]> {
      return this._http.get<JobsiteOverview[]>(this.GetAllJobsitesApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllJobsitesApiAddress).share().map(
        //     (response: Response) => <JobsiteOverview[]>response.json()).catch(this.handleError);
    }

    public getAllJobsitesForAdmin(jobsiteTableLoadingComplete : any): Observable<JobsiteOverview[]> {
      return this._http.post<JobsiteOverview[]>(this.GetAllJobsitesApiAddress,jobsiteTableLoadingComplete).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllJobsitesApiAddress).share().map(
        //     (response: Response) => <JobsiteOverview[]>response.json()).catch(this.handleError);
    }


    public addNewJobsite(newJobsite: NewJobsite): Observable<number> {
      return this._http.post<number>(this.AddNewJobsiteApiAddress, newJobsite).pipe(catchError(this.handleError));
        // return this._http.post(this.AddNewJobsiteApiAddress, newJobsite).share().map(
        //     (response: Response) => <number>response.json()).catch(this.handleError);
    }

    public updateJobsite(newJobsite: UpdateJobsite): Observable<Tuple> {
      return this._http.post<Tuple>(this.UpdateJobsiteApiAddress, newJobsite).pipe(catchError(this.handleError));
        // return this._http.post(this.UpdateJobsiteApiAddress, newJobsite).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}
